import React, { useMemo, useState } from 'react';
import { LuChevronRight, LuX } from 'react-icons/lu';
import Button from '../../molecules/Button';
import ModalContainer from '../../molecules/ModalContainer';
import PricingSection from '../Pricing/PricingSection';

const TRIAL_DURATION_DAYS = 7;

const TrialBanner = ({ onClose, onCloseStart, user }) => {
  const [isClosing, setIsClosing] = useState(false);
  const userDetails = user?.data || user;
  const daysLeft = useMemo(() => {
    const createdAt = userDetails?.created_at;
    if (!createdAt) {
      return TRIAL_DURATION_DAYS;
    }

    const createdDate = new Date(createdAt);
    if (Number.isNaN(createdDate.getTime())) {
      return TRIAL_DURATION_DAYS;
    }

    const elapsedMs = Date.now() - createdDate.getTime();
    const elapsedDays = Math.max(0, Math.floor(elapsedMs / (1000 * 60 * 60 * 24)));
    return Math.max(0, TRIAL_DURATION_DAYS - elapsedDays);
  }, [userDetails?.created_at]);

  const handleClose = () => {
    setIsClosing(true);
    if (onCloseStart) onCloseStart();
    // Delay the actual unmounting until the 350ms animation completes
    setTimeout(() => {
      if (onClose) onClose();
    }, 350);
  };

  return (
    <div className={`trial-banner ${isClosing ? 'closing' : ''}`}>
      <div className="content-holder">
        <span className="trial-banner-text">
          Your Free Trial Ends In {daysLeft} Days |{' '}
          <span className="trial-banner-upgrade-text"> Upgrade To Keep Your Campaigns Running</span>
        </span>
        <ModalContainer
          newStyle
          width={1200}
          btnComponent={({ onClick }) => (
            <Button
              variant="dark"
              className="upgrade-btn"
              rounded
              width="150px"
              onClick={onClick}
              aria-label="Upgrade now">
              Upgrade Now <LuChevronRight size={14} color="var(--white)" />
            </Button>
          )}
          content={({ onClose }) => <PricingSection onClose={onClose} />}
        />
      </div>
      <button type="button" className="trial-banner-close-btn" onClick={handleClose} aria-label="Close trial banner">
        <LuX size={22} color="var(--white)" />
      </button>
    </div>
  );
};

export default TrialBanner;
